/**
 * File Name          : choose-level.component.ts
 * Author             : Jared Laine Dyreson
 * Version            : 0.1.0
 * Date               : 2026-03-18
 * Description        : Short Description (manual edit required)
 * 
 * Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * This file is subject to the terms and conditions defined in
 * file 'IDL_PROJECTTECH_LICENSE.txt', which is part of this source code package.
 */

import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { DatasnapUnit, UNITS } from '../../models/lessons.model';
import { DatasnapDeviceService } from '../../services/datasnap-device.service';
import { DxButtonModule } from "devextreme-angular";
import { CommonModule } from '@angular/common';
import { ScreenserviceService } from '../../services/screenservice.service';
import { filter } from 'rxjs';

@Component({
  selector: 'app-choose-level',
  standalone: true,
  imports: [CommonModule, DxButtonModule],
  templateUrl: './choose-level.component.html',
  styleUrl: './choose-level.component.scss'
})
export class ChooseLevelComponent {
  unitId!: string;
  unit: DatasnapUnit|undefined;
  
  constructor(private activatedRoute: ActivatedRoute, private datasnapDeviceService: DatasnapDeviceService, private router: Router, public screenservice: ScreenserviceService) {

  }

  ngOnInit() {
      // // Subscribe to router events to detect navigation changes
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd)
      ).subscribe(() => {
        this.updateFromRoute();
      });
  
      // // Initial load
      this.updateFromRoute();
  }

  private updateFromRoute() {
    // Access the deepest child route to get all params
    let child = this.activatedRoute;
    while (child) {
      if (child.firstChild) {
        child = child.firstChild;
      } else {
        this.unitId = this.activatedRoute.snapshot.paramMap.get('unitId') ?? '';
        this.unit = UNITS.find(l => l.id === this.unitId);
        if(!this.unit) {
          this.router.navigate(['home'])
        }
        console.log('unit id is ', this.unit!.id)
        
        break;
      }
    }
  }

  openLevel = (levelId: string) => {
    this.router.navigate(['/home', this.unitId, levelId]);
  }
}
